import DriverForm from "../lp/DriverForm";
import { usePageSetup } from "./usePageSetup";

/** /driver — ABテストのA（こだわり条件の設問なし） */
export default function DriverA() {
  usePageSetup("A");
  return <DriverForm variant="A" />;
}
